export function canConvertToJson(json) {
	try {
		return JSON.parse(json)
	} catch (error) {
		return false
	}
}